import React, { useMemo, useState } from "react";
import { Button, Container, Dropdown, Header, Icon, List, Modal, Popup } from "semantic-ui-react";
import { messages } from "../../../../config/constants";
import { doesNotExist, exists } from "../../../../utils/utils";
import DismissibleMessage from "../../../common/DismissibleMesage";
import SearchableTable from "../../../common/SearchableTable";

const marginTop = { marginTop: "2%" };
const Regions = ({ userRegions, publicRoles, onPublicRegionJoin, disabled, isExternal }) => {
  const [open, setOpen] = useState(false);
  const [selection, setSelection] = useState([]);
  const handleChange = (event, { value }) => {
    setSelection(value);
  };
  const renderLabel = label => ({
    color: "blue",
    content: label.text,
    icon: "check"
  });
  const columns = [
    {
      Header: <p style={{ fontSize: "14px" }}>Region</p>,
      accessor: "region",
      // eslint-disable-next-line react/display-name
      Cell: ({ value: region }) => (
        <>
          <p style={{ fontSize: "14px", display: "inline" }}> {region.name}</p>
          <Popup
            basic
            trigger={
              <Icon
                style={{ display: "inline", marginLeft: "1%" }}
                color="grey"
                name="info circle"
              />
            }
          >
            <Header as="h4">Region Info</Header>
            <List>
              <List.Item>
                <b>Model:</b> {region.modelType}
              </List.Item>
              <List.Item>
                <b>Region ID:</b> {region.id}
              </List.Item>
              <List.Item>
                <b>SRS:</b> {region.srs}
              </List.Item>
              <List.Item>
                <b>MPO ID:</b> {region.mpoId}
              </List.Item>
              <List.Item>
                <b>Base Year:</b> {region.baseYear}
              </List.Item>
            </List>
          </Popup>
        </>
      ),
      sortType: (previous, current, id) => {
        if (previous.values[id].name.toLowerCase() > current.values[id].name.toLowerCase()) {
          return 1;
        } else if (previous.values[id].name.toLowerCase() < current.values[id].name.toLowerCase()) {
          return -1;
        } else {
          return 0;
        }
      },
      filter: "region"
    }
  ];
  const filterTypesConditions = {
    region: (rowValue, filterValue) => {
      return String(rowValue.name)
        .toLowerCase()
        .includes(String(filterValue).toLowerCase());
    }
  };
  const data = userRegions.map(region => {
    const regionToMap = { ...region };
    if (exists(regionToMap["mpo_id"]) && doesNotExist(regionToMap.mpoId)) {
      regionToMap.mpoId = regionToMap["mpo_id"];
    }
    if (exists(regionToMap["base_year"]) && doesNotExist(regionToMap.baseYear)) {
      regionToMap.baseYear = regionToMap["base_year"];
    }
    return { region: regionToMap };
  });
  const options = useMemo(
    () =>
      publicRoles.map(role => ({
        key: role.id,
        text: `${role.region.name}`,
        value: role
      })),
    [publicRoles]
  );

  return (
    <Container text>
      <Header>Your Regions</Header>
      {isExternal && (
        <DismissibleMessage
          className={messages.hasExternalSubscription.className}
          content={messages.hasExternalSubscription.content}
        />
      )}
      <SearchableTable
        columns={columns}
        data={data}
        filterTypesConditions={filterTypesConditions}
      />

      {publicRoles.length === 0 ? (
        <Button disabled style={marginTop}>
          No public regions available
        </Button>
      ) : (
        <Modal
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          open={open}
          size="small"
          trigger={
            <Button style={marginTop} color="green" disabled={disabled}>
              Join a public region
            </Button>
          }
          closeIcon
        >
          <Header icon="globe" content={`Public regions`} />
          <Modal.Content>
            <Dropdown
              aria-label="Region selection"
              renderLabel={renderLabel}
              placeholder="Regions"
              fluid
              selection
              multiple
              value={selection}
              onChange={handleChange}
              options={options}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button
              type="submit"
              disabled={selection.length === 0}
              onClick={() => {
                onPublicRegionJoin(selection.map(role => role.id));
                setSelection([]);
                setOpen(false);
              }}
              color="green"
            >
              <Icon name="checkmark" /> Join
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </Container>
  );
};

export default Regions;
